<template>
	<Icon>
        <i class="fa fa-times"></i>
    </Icon>
</template>

<script>
export default {}
</script>
